import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=6bf3a625&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=6bf3a625&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3a625",
  null
  
)

export default component.exports